import { type ReactNode } from 'react';

import {
  Dialog as DialogRoot,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ui/components/base/dialog';
import { cn } from '@ui/lib/utils';

const DIVIDED_HEADER_CLASSNAME = '-mx-4 -mt-4 min-h-16 justify-center border-b border-border px-6 py-3';
const DIVIDED_CLOSE_BUTTON_CLASSNAME = 'top-4.5 right-4';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  showCloseButton?: boolean;
  dividedHeader?: boolean;
  className?: string;
  zIndex?: number;
}

const Dialog = ({
  open,
  onClose,
  title,
  description,
  footer,
  children,
  showCloseButton = true,
  dividedHeader = false,
  className,
  zIndex,
}: DialogProps) => (
  <DialogRoot
    open={open}
    onOpenChange={(nextOpen: boolean) => {
      if (!nextOpen) {
        onClose();
      }
    }}
  >
    <DialogContent
      className={className}
      showCloseButton={showCloseButton}
      closeButtonClassName={cn(dividedHeader && DIVIDED_CLOSE_BUTTON_CLASSNAME)}
      zIndex={zIndex}
    >
      {(title || description) && (
        <DialogHeader className={cn(dividedHeader && DIVIDED_HEADER_CLASSNAME)}>
          {title && <DialogTitle className={cn(dividedHeader && 'text-xl font-bold')}>{title}</DialogTitle>}
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
      )}
      {children}
      {footer && <DialogFooter>{footer}</DialogFooter>}
    </DialogContent>
  </DialogRoot>
);

export { Dialog };
export type { DialogProps };
